/**
 * DrumMidiExport — write the detected hits (DrumKitSwap.detect) as a Standard
 * MIDI File, type 0, GM drum map on channel 10:
 *   kick → 36, snare → 38, toms → 47 / 45 / 41 (hi / mid / floor, cycling
 *   like the kit swap does), velocity 1..127 from the detector's 0..1.
 *
 *   const blob = DrumMidiExport.toBlob(hits, { bpm: 120, ppq: 480 })
 *   const bpm  = DrumMidiExport.estimateBpm(hits)   // median kick+snare gap → BPM
 *
 * Absolute-time events are converted to delta ticks against the estimated
 * tempo, so the file opens in a DAW on a sensible grid; the timing itself is
 * exact to the tick (ppq 480 → ~1 ms at 120 BPM). Demand: «миди из аудио»
 * 285/мес (Wordstat, 2026-08-16); drummers and beat-makers "lift" grooves this way.
 */
(function(){
'use strict';

var NOTE = { kick: [36], snare: [38], toms: [47, 45, 41] };

function vlq(n){ var b = [n & 0x7f]; n >>= 7; while (n > 0) { b.unshift((n & 0x7f) | 0x80); n >>= 7; } return b; }
function u32(n){ return [(n >>> 24) & 255, (n >>> 16) & 255, (n >>> 8) & 255, n & 255]; }
function u16(n){ return [(n >>> 8) & 255, n & 255]; }
function u24(n){ return [(n >>> 16) & 255, (n >>> 8) & 255, n & 255]; }
function str(s){ var a = []; for (var i = 0; i < s.length; i++) a.push(s.charCodeAt(i) & 255); return a; }

// Median inter-onset interval of kick+snare, folded into 60..200 BPM. Not a
// beat tracker — a grid guess so the DAW ruler is not absurd; timings stay exact.
function estimateBpm(hits){
    // Snare-to-snare: in 4/4 the backbeat lands on 2 and 4, so its median gap is a
    // half note → BPM = 120/gap. Kick+snare merged gave half-bar gaps and read a
    // 102 BPM demo as 199 (QA 2026-08-16). Fall back to kick-to-kick as a quarter.
    function medianGap(list){ var ts = (list || []).map(function(h){ return h.t; }).sort(function(a, b){ return a - b; }); var gaps = []; for (var i = 1; i < ts.length; i++) { var g = ts[i] - ts[i - 1]; if (g > 0.15 && g < 2.5) gaps.push(g); } if (gaps.length < 4) return 0; gaps.sort(function(a, b){ return a - b; }); return gaps[gaps.length >> 1]; }
    var bpm = 0, sg = medianGap(hits.snare);
    if (sg) bpm = 120 / sg;
    if (!bpm) { var kg = medianGap(hits.kick); if (kg) bpm = 60 / kg; }
    if (!bpm) return 120;
    while (bpm > 180) bpm /= 2; while (bpm < 70) bpm *= 2;
    return Math.round(bpm);
}

function toBlob(hits, opts){
    opts = opts || {};
    var ppq = opts.ppq || 480, bpm = opts.bpm || estimateBpm(hits), name = opts.name || 'Timbrica drums';
    var events = [];   // {tick, bytes[]}
    var toTick = function(t){ return Math.round(t * bpm / 60 * ppq); };
    ['kick', 'snare', 'toms'].forEach(function(part){
        var list = hits[part] || [], notes = NOTE[part];
        for (var i = 0; i < list.length; i++) {
            var n = notes[i % notes.length], v = Math.max(1, Math.min(127, Math.round(list[i].v * 127))), on = toTick(list[i].t);
            events.push({ tick: on, bytes: [0x99, n, v] });                       // note on, ch 10
            events.push({ tick: on + Math.round(ppq / 8), bytes: [0x89, n, 0] }); // note off 1/32 later
        }
    });
    events.sort(function(a, b){ return a.tick - b.tick || (a.bytes[0] & 0xf0) - (b.bytes[0] & 0xf0); });
    var track = [];
    track = track.concat([0x00, 0xff, 0x03], vlq(name.length), str(name));                        // track name
    track = track.concat([0x00, 0xff, 0x51, 0x03], u24(Math.round(60000000 / bpm)));              // tempo
    track = track.concat([0x00, 0xff, 0x58, 0x04, 4, 2, 24, 8]);                                  // 4/4
    track = track.concat([0x00, 0xc9, 0x00]);                                                     // program 0 on ch 10 (standard kit)
    var last = 0;
    events.forEach(function(e){ track = track.concat(vlq(e.tick - last), e.bytes); last = e.tick; });
    track = track.concat([0x00, 0xff, 0x2f, 0x00]);                                               // end of track
    var head = [].concat(str('MThd'), u32(6), u16(0), u16(1), u16(ppq));
    var body = [].concat(str('MTrk'), u32(track.length), track);
    return new Blob([new Uint8Array(head.concat(body))], { type: 'audio/midi' });
}

window.DrumMidiExport = { toBlob: toBlob, estimateBpm: estimateBpm, version: '1.0.0' };
})();
